module.exports = __webpack_public_path__ + "img/android-code.858f12be.png";